import * as RetirementWorkflowConstants from '../RetirementWorkflow/RetirementWorkflowConstants';
import * as DebtManagementWorkflowConstants from '../DebtManagementWorkflow/DebtManagementWorkflowConstants';
import * as EducationWorkflowConstants from '../EducationWorkflow/EducationWorkflowConstants';
import * as HomePurchaseWorkflowConstants from '../HomePurchaseWorkflow/HomePurchaseWorkflowConstants';
import * as EmergencyFundWorkflowConstants from '../EmergencyFundWorkflow/EmergencyFundWorkflowConstants';
import * as LargePurchaseWorkflowConstants from '../LargePurchaseWorkflow/LargePurchaseWorkflowConstants';
import * as FinancialAccountsWorkflowConstants from '../FinancialAccountsWorkflow/FinancialAccountsWorkflowConstants';
import * as HealthcareWorkflowConstants from '../HealthcareWorkflow/HealthcareWorkflowConstants';
import * as DecumulationWorkflowConstants from '../DecumulationWorkflow/DecumulationWorkflow.constants';

export const ENDPOINT_URL_MAP = {
  [RetirementWorkflowConstants.WORKFLOW_ID]: 'Consumer/RetirementWorkflow',
  [DebtManagementWorkflowConstants.WORKFLOW_ID]: 'Consumer/DebtManagementWorkflow',
  [EducationWorkflowConstants.WORKFLOW_ID]: 'Consumer/EducationWorkflow',
  [HomePurchaseWorkflowConstants.WORKFLOW_ID]: 'Consumer/HomePurchaseWorkflow',
  [EmergencyFundWorkflowConstants.WORKFLOW_ID]: 'Consumer/EmergencyFundWorkflow',
  [LargePurchaseWorkflowConstants.WORKFLOW_ID]: 'Consumer/LargePurchaseWorkflow',
  [FinancialAccountsWorkflowConstants.WORKFLOW_ID]: 'Consumer/AccountsWorkflow',
  [HealthcareWorkflowConstants.WORKFLOW_ID]: 'Consumer/HealthCareWorkflow',
  [DecumulationWorkflowConstants.WORKFLOW_ID]: 'Consumer/DecumulationWorkflow',
};

export const UPDATE_ENDPOINT_URL_MAP = {
  [RetirementWorkflowConstants.WORKFLOW_ID]: 'Consumer/RetirementWorkflowUpdate',
  [DebtManagementWorkflowConstants.WORKFLOW_ID]: 'Consumer/DebtManagementWorkflowUpdate',
  [EducationWorkflowConstants.WORKFLOW_ID]: 'Consumer/EducationWorkflowUpdate',
  [HomePurchaseWorkflowConstants.WORKFLOW_ID]: 'Consumer/HomePurchaseWorkflowUpdate',
  [EmergencyFundWorkflowConstants.WORKFLOW_ID]: 'Consumer/EmergencyFundWorkflowUpdate',
  [LargePurchaseWorkflowConstants.WORKFLOW_ID]: 'Consumer/LargePurchaseWorkflowUpdate',
  [FinancialAccountsWorkflowConstants.WORKFLOW_ID]: 'Consumer/AccountsWorkflowUpdate',
  [HealthcareWorkflowConstants.WORKFLOW_ID]: 'Consumer/HealthCareWorkflowUpdate',
  [DecumulationWorkflowConstants.WORKFLOW_ID]: 'Consumer/DecumulationWorkflowUpdate',
};

export const SEED_DATA_EXCEPTION_MESSAGE =
  "Couldn't get seed data. Please check if the endpoint is working.";
